<script lang="ts">
import Vue from 'vue';
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import AddButton from '@/views/organizations/components/AddButton.vue';
import AddStructureModal from '@/views/organizations/components/AddStructureModal.vue';

export default Vue.extend({
  name: 'BaseHeader',
  components: { AddButton, Breadcrumbs, AddStructureModal },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
    }
  },
});
</script>

<template>
<div>
    <AddStructureModal v-model="showModal" @saved="$emit('saved')"/>
    <div class="d-flex justify-content-between mb-4 title-block">
        <div class="header-page">
            <div class="title">
                {{ $route.meta.title }}
            </div>
            <Breadcrumbs/>
        </div>
        <AddButton @click="openModal" v-if="$route.name !== 'organizations.tariff-settings'">
            <template>
                <div>
                    +
                </div>
                <div>
                    Додати структуру
                </div>
            </template>
        </AddButton>
    </div>
</div>
</template>

<style scoped lang="scss">
.header-page {
    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    gap: 8px;

    .title {
        font-family: Geist,serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 28px;
        color: #09090B;

        /* Inside auto layout */
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
    }
}

@media (max-width: 550px) {
    .title-block {
        flex-direction: column;
    }

    .header-page {
        padding-bottom: 16px;
    }
}
</style>
